export default __webpack_public_path__ + "static/media/real-assets.ea37045e.svg";